import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {UploadView} from "../views/upload";

export class UploadFunction extends AppFunction {

    readonly v : View;

    constructor(id: number | undefined) {
        super();
        this.v = new UploadView(id);
    }

    view() {
        return this.v;
    }

    url() {
        return `/upload`;
    }
}
